import type {Margin} from '@yandex-delivery/blocks'
import type {Dir} from '@yandex-delivery/client-core/config'

export const MAP_MARGIN_BY_DIRECTION: Readonly<Record<Dir, Margin>> = {
  ltr: [0, 385, 0, 0],
  rtl: [0, 0, 0, 385],
}

export const MAX_ZOOM_TO_SHOW_POPUP = 16
